import styles from './SummaryPanel.module.scss';

export const SummaryIcon = ({ icon, isActive=false }) => {
  return <div className={`${styles.summaryIconContainer} ${isActive ? styles.activeSummaryIcon : ''}`}>{icon}</div>;
}